<button [ngClass]="{'btn btn-outline': outline, 'btn btn-cancelar': cancelar, 'btn button-primary': !outline, 'disabled':disabled, 'btn-acceso':btnAcceso, 'btn-outlineYellow': outlineYellow}" (click)="clicked()">
          <span class="btn-icon" *ngIf="icono">
            <svg [class]="icono">
              <use [attr.xlink:href]="icono|iconoRef"></use>
            </svg>
          </span>
          <span class="btn-text">{{titulo}}</span>
</button>
